import { render, staticRenderFns } from "./cbmnetTrsaccRsultInqRpt2.vue?vue&type=template&id=ca0a5d4a"
import script from "./cbmnetTrsaccRsultInqRpt2.vue?vue&type=script&lang=js"
export * from "./cbmnetTrsaccRsultInqRpt2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca0a5d4a')) {
      api.createRecord('ca0a5d4a', component.options)
    } else {
      api.reload('ca0a5d4a', component.options)
    }
    module.hot.accept("./cbmnetTrsaccRsultInqRpt2.vue?vue&type=template&id=ca0a5d4a", function () {
      api.rerender('ca0a5d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/transfer/cbmnetTrsaccRsultInqRpt2.vue"
export default component.exports